import theme from '../../base';

const box = {
  bg: theme.colors.neutrals.gray850,
};

export default box;
